import React from 'react';
import clsx from 'clsx';

import { Icon } from '@components/index';
import { SectionHeadersType } from '@types';

export type GroupMemberSidebarItem = {
  id: SectionHeadersType;
  label: string;
  icon: string;
  ref: React.RefObject<HTMLElement>;
};

type Props = {
  items: GroupMemberSidebarItem[];
  focusedSidebarItem: SectionHeadersType;
  onSidebarItemClick: (ref: React.RefObject<HTMLElement>) => void;
};

const GroupMemberModalSidebar = ({
  items,
  focusedSidebarItem,
  onSidebarItemClick
}: Props) => (
  <div className="flex flex-col pt-6">
    <div className="space-y-3 rounded-xl">
      {items.map((item) => (
        <button
          key={item.id}
          type="button"
          className={`flex w-full items-center gap-3 rounded-lg px-4 py-3 text-left ${
            focusedSidebarItem === item.id
              ? 'bg-primaryLite9'
              : 'hover:bg-grey10'
          }`}
          onClick={() => {
            onSidebarItemClick(item.ref);
          }}
        >
          <Icon
            name={item.icon}
            className={clsx(
              focusedSidebarItem === item.id ? 'text-primary' : 'text-bgGrey'
            )}
          />
          {item.label}
        </button>
      ))}
    </div>
  </div>
);

export default GroupMemberModalSidebar;
